var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", {
    staticClass: "review-card-logo flex-shrink-0",
    class: { "review-card-logo--watermark": _vm.isWatermark },
    style: _setup.logoStyle,
    attrs: { "aria-hidden": "true" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }